/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY2FuZGlkYXRlL2NvbXBvbmVudHMvY2FuZGlkYXRlLWZhbWlsaWFyLXN0cnVjdHVyZS9jYW5kaWRhdGUtZmFtaWxpYXItc3RydWN0dXJlLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2NhbmRpZGF0ZS9jb21wb25lbnRzL2NhbmRpZGF0ZS1mYW1pbGlhci1zdHJ1Y3R1cmUvY2FuZGlkYXRlLWZhbWlsaWFyLXN0cnVjdHVyZS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/candidate/components/candidate-familiar-structure/candidate-familiar-structure.component.scss.shim.ngstyle.ts